export const reImei = /^\d{15}$/;

export const reNumericString = /^((-?[0-9]+\.[0-9]*)|(-?[0-9]*\.[0-9]+)|(-?[0-9]+))$/;
